import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component'
import {useGetCommissionDetail, useGetCommissionList} from '../../context/useQuery'
import {useStore} from '../../hook'

const StoreComissionDetail = ({loading}: {loading: boolean}) => {
  const intl = useIntl()
  const {detail, comissionDetail, commissionList, commissionListFilter, commissionListFilterSet} =
    useStore()

  useGetCommissionDetail(detail?.id || '')
  useGetCommissionList()

  const content = comissionDetail?.commission || null
  const list = commissionList.dataList || []
  const paging = commissionList.paging || {
    currentPageNumber: 0,
    totalPagesNumber: 0,
    pageSize: 0,
    totalCount: 0,
  }

  const Columns = [
    {
      key: 'min',
      dataIndex: 'min',
      title: intl.formatMessage({id: 'STORE.DETAIL.COMMISSION_DETAIL.MIN'}) + ' ($)',
      monetize: true,
    },
    {
      key: 'max',
      dataIndex: 'max',
      title: intl.formatMessage({id: 'STORE.DETAIL.COMMISSION_DETAIL.MAX'}) + ' ($)',
      monetize: true,
    },
    {
      key: 'commission',
      dataIndex: 'commission',
      title: intl.formatMessage({id: 'STORE.DETAIL.COMMISSION_DETAIL.COMMISSION'}) + ' (%)',
      monetize: true,
    },
    {
      key: 'fee',
      dataIndex: 'commissionFee',
      title: intl.formatMessage({id: 'STORE.DETAIL.COMMISSION_DETAIL.FEE'}) + ' ($)',
      monetize: true,
    },
  ]

  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header'>
          <div className='card-title m-0'>
            <h3 className='fw-bold m-0'>
              {intl.formatMessage({id: 'STORE.DETAIL.COMMISSION_DETAIL'})}
            </h3>
          </div>
        </div>

        {content && (
          <div className='card-body p-9'>
            <div className='row'>
              <div className='col'>
                {/* <div className='column mb-7'>
                  <label className='col-lg-4 fw-semibold '>
                    {intl.formatMessage({id: 'STORE.DETAIL.COMMISSION_DETAIL.CHAIN'})}
                  </label>

                  <div className='col-lg-12 fv-row'>
                    <span className='fw-semibold text-gray-800 fs-6'>{content.chainName}</span>
                  </div>
                </div> */}

                <div className='column mb-7'>
                  <label className='col-lg-4 fw-semibold '>
                    {intl.formatMessage({id: 'STORE.DETAIL.COMMISSION_DETAIL.TYPE'})}
                  </label>

                  <div className='col-lg-4 mt-2'>
                    <span className='fw-semibold text-gray-800 fs-6'>
                      {content.paymentTypeName}
                    </span>
                  </div>
                </div>
              </div>
              <div className='col'>
                <div className='column mb-7'>
                  <label className='col-lg-4 fw-semibold '>
                    {intl.formatMessage({id: 'STORE.DETAIL.COMMISSION_DETAIL.STORE'})}
                  </label>

                  <div className='col-lg-12'>
                    <span className='fw-semibold text-gray-800 fs-6'>{content.storeName}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-body p-9'>
          <Table
            loading={false}
            dataSource={list}
            columns={Columns}
            pagination={{
              current: paging.currentPageNumber,
              pageSize: paging.pageSize,
              total: paging.totalCount,
              onChange: (page: any) => {
                const {pageSize, current} = page
                const currentPage = pageSize !== paging.pageSize ? 1 : current

                commissionListFilterSet({
                  ...commissionListFilter,
                  paging: {
                    currentPageNumber: currentPage,
                    pageSize: pageSize,
                  },
                })
              },
            }}
          />
        </div>
      </div>
    </>
  )
}

export default StoreComissionDetail
